import { IdName } from '../../../shared/models/idName';
import { EmployeeInvoice } from './employee-invoice';
import * as moment from 'moment';

const dateFormat = 'MM/DD/YYYY hh:mm A';

export class EmployeeScoreDetails {
    employee: IdName;
    invoices: EmployeeInvoice[];

    constructor(data: EmployeeScoreDetails) {
        Object.assign(this, data);

        // format dates
        if (!this.invoices) { return; }

        this.invoices.forEach(invoice => invoice.timestamp = moment(invoice.timestamp).format(dateFormat))
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/shared/models/employee-score-details.ts